import { palette } from '@livable/saas-react-components';
const MuiLink = {
  styleOverrides: {
    root: {
      color: palette.primary.dark,
      transition: "color ".concat(palette.transitions.short),
      textDecoration: 'none',
      '&:hover': {
        color: palette.primary.dark
      },
      '&.Mui-focusVisible': {
        outlineColor: palette.primary.dark,
        color: palette.shades[800]
      }
    }
  }
};
export default MuiLink;